<template>
  <el-header v-if="$store.state.user" class="nav-container">
    <el-menu
      mode="horizontal"
      background-color="#0c0526"
      text-color="#fff"
      active-text-color="#fff"
      router
    >
      <el-menu-item class="menu flex-center d-none">
        <i class="fas fa-bars"></i>
      </el-menu-item>
      <el-menu-item class="logo" index="/">
        <img id="logo" src="@/assets/images/logo.svg" />
      </el-menu-item>
      <li class="avatar-dropdown float-right">
        <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="fas fa-user-circle"
              @click.native="openProfile()"
              >Profile</el-dropdown-item
            >
            <el-dropdown-item icon="fas fa-sign-out-alt" @click.native="logout('content')"
              >Log Out</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <el-menu-item class="float-right username">
        <p>{{ user.first_name }} {{ user.surname }}</p>
      </el-menu-item>
    </el-menu>
  </el-header>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['user'])
  },

  data() {
    return {
      search: '',
      url: process.env.VUE_APP_STORAGE_URL,
      dev: process.env.VUE_APP_IN_DEVELOPMENT
    }
  }
}
</script>

<style lang="scss" scoped>
.el-header {
  position: fixed;
  z-index: 110;
  left: 0;
  width: 100%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
}

.el-icon-s-data,
.el-icon-mic {
  color: #ffffff;
}

p {
  margin: 0;
}

.logo {
  #logo {
    width: 9.5rem;
    padding: 0 3.35rem;
  }
}

.avatar {
  padding: 0;
  &:hover {
    background-color: none;
  }
}

.dropdown-item {
  height: 45px !important;
  border: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white !important;
  i {
    color: #666666;
  }
  &:hover {
    background-color: #eeebeb !important;
    i {
      color: #444444;
    }
  }
}

.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
  &:hover {
    border-bottom: none !important;
    background-color: transparent !important;
  }
}

.el-menu {
  height: 85px;
  .el-menu-item,
  .el-submenu {
    line-height: 85px;
    height: 85px;
    border-bottom: none;
    text-align: center;
  }
}

@media screen and (max-width: 991px) {
  .logo {
    width: 70%;
    padding: 0;
    border-right: none;
  }
  .search,
  .menu {
    width: 15%;
    padding: 0;
    display: flex !important;
  }
  .logo-dark {
    padding-left: 0;
  }
  .el-menu > :not(.search, .menu, .logo) {
    display: none;
  }
}
</style>
